import { apiClient } from '@/provider';
import { prepareSchema } from '@/provider/utils';
import geoItemScheme from './geo-item.graphql';

const SCHEME_NAME_PREFIX = 'PixelMonitor Object Geo Item, ';
const addNamePrefix = name => `${SCHEME_NAME_PREFIX}${name}`;

export default {
  fetchBaseGeoItemSchemaId() {
    return apiClient
      .query({
        query: geoItemScheme.fetchBaseGeoItemSchemaId
      })
      .then(r => r.data.schemata[0]?.id || '');
  },
  async fetch(id) {
    const res = await apiClient.query({
      query: geoItemScheme.fetch,
      variables: {
        id
      },
      fetchPolicy: 'no-cache'
    });
    return prepareSchema(res.data.schema);
  },
  create({ name, schemaId, parentSchemaId }) {
    return apiClient
      .mutate({
        mutation: geoItemScheme.create,
        variables: {
          input: {
            newSchemaName: addNamePrefix(name),
            schemaId,
            newSchemaTags: ['application', 'monitor', 'object geo item'],
            linkToSchemaId: parentSchemaId
          }
        }
      })
      .then(r => r.data?.createSchemaCopy?.uuid);
  },

  update(id, { name, description }) {
    return apiClient.mutate({
      mutation: geoItemScheme.update,
      variables: {
        id,
        name: addNamePrefix(name),
        description
      }
    });
  }
};
